import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { ConfigKey, MapConfigState } from '@/types';

import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface Option {
  key: ConfigKey;
  label: string;
}

interface ConfigSectionProps {
  title: string;
  options: Option[];
  config: MapConfigState;
  onToggle: (key: ConfigKey) => void;
}

const ConfigSection: FC<ConfigSectionProps> = ({ title, options, config, onToggle }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3">
      <h4 className="text-sm font-semibold text-muted-foreground">{title}</h4>
      <div className="flex flex-col gap-3">
        {options.map(({ key, label }) => (
          <div key={key} className="flex justify-between items-center">
            <Label htmlFor={key} className="text-sm font-normal text-foreground cursor-pointer">
              {t(label)}
            </Label>
            <Switch
              id={key}
              checked={config[key]}
              onCheckedChange={() => onToggle(key)}
              className="data-[state=checked]:bg-primary"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConfigSection;
